export const organization = {
  name: "Asociația Umanitară Pentru Promovarea Sănătății „Personocrația”",
  cif: "29417910",
  address: "Sat Baba nr. 68, Comuna Horea, județul Alba",
  email: "info@promovareasanatatii.ro",
  phone: "0747 179 922",
  phoneHref: "tel:+40747179922",
} as const;
